// extracted by mini-css-extract-plugin
module.exports = {"iconWrapper":"TitleIconSmall_iconWrapper__F667c","title":"TitleIconSmall_title__yBMHh","titleWrapper":"TitleIconSmall_titleWrapper__awVgD"};